import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { ClaimResponse } from '@ecosure-suite/shared/util-entities';
import { Observable } from 'rxjs';
import { ClaimRequestsService } from '../claim-requests.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClaimDetailsRequestResolverService
  implements Resolve<ClaimResponse> {
  constructor(private claimRequestsService: ClaimRequestsService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): ClaimResponse | Observable<ClaimResponse> | Promise<ClaimResponse> {
    return this.claimRequestsService.getClaimByNationalId(+route.params['nationalId']);
  }
}
